import React from 'react';
import Select from 'react-select';

import fetchContent from '../../helpers/backend-communication';

export const GLOBAL_REGION = {
  regionalGroup: 'GLOBAL',
  regionMetaSet: [
    {
      name: 'Global'
    }
  ],
  countryCount: 193,
}

const OPTION_GLOBAL = {
  value: 'GLOBAL',
  label: 'Global',
}

function getOptions(regions, totalText) {
  const globalOption = {
    ...OPTION_GLOBAL,
    label: totalText ? totalText : OPTION_GLOBAL.label
  }
  const regionOptions = regions.map(({ regionalGroup, regionMetaSet }) => ({
    value: regionalGroup,
    label: regionMetaSet && regionMetaSet.length !== 0 ? regionMetaSet[0].name : "Invalid label"
  }));
  return [globalOption, ...regionOptions]
}

class RegionalGroupSelect extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      isLoading: false,
      data: [],
      dataMap: {},
    };

    this.onLoading = this.onLoading.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    this.fetchData(
      this.props.onLoading
    );
  }

  fetchData(onLoading) {
    this.onLoading(true);
    fetchContent('regions')
      .then(responseObject => {
        this.setState({
          data: responseObject.data,
          dataMap: Object.fromEntries(
            responseObject.data.map(
              (item) => [item.regionalGroup, item]
            )
        ),
        });
        this.onLoading(false);
      })
      .catch(error => {
        this.onLoading(false);
      });
  }

  onLoading(isLoading) {
    this.setState({ isLoading });
  }

  onChange(selectedValue) {
    if (selectedValue.value === OPTION_GLOBAL.value) {
      this.props.onChange(GLOBAL_REGION)
    } else {
      this.props.onChange(this.state.dataMap[selectedValue.value])
    }
  }

  render() {
    const { value, textForTotal, className } = this.props
    const { data, isLoading } = this.state
    const options = !isLoading && data && data.length !== 0 ? getOptions(data, textForTotal) : []
    return (
      <div style={{ position: 'relative' }}>
        <span
          style={{ position: 'absolute', top: 0, left: 0 }}
          className="glyphicon glyphicon-globe"
        />
        <Select
          name="regional-group-selector"
          value={value}
          options={options}
          onChange={this.onChange}
          disabled={isLoading}
          searchable={false}
          clearable={false}
          placeholder="Select a group / region"
          className={className}
        />
      </div>
    );
  }
}

export default RegionalGroupSelect;



// WEBPACK FOOTER //
// ./src/components/Selects/RegionalGroup.js